import React from "react";
import { Link } from "react-router-dom"; // ✅ Import React Router for navigation

const Editorpop = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 editor-login-popup">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] sm:w-[400px]">
        <h2 className="text-xl font-semibold mb-4 text-center">Join to Access Editor</h2>
        <p className="text-gray-600 text-sm mb-4 text-center">
          Create an account or log in to start using editor.
        </p>

        <div className="flex flex-col space-y-3">
          {/* ✅ Sign Up links to /register */}
          <Link
            to="/register"
            className="w-full bg-primary text-white py-2 rounded-md hover:bg-secondary transition text-center"
          >
            Sign Up
          </Link>

          {/* ✅ Login links to /login */}
          <Link
            to="/login"
            className="w-full bg-gray-300 text-black py-2 rounded-md hover:bg-gray-400 transition text-center"
          >
            Login
          </Link>
        </div>

        {/* ✅ Close button */}
        <button
          onClick={onClose}
          className="mt-4 text-sm text-gray-500 hover:text-gray-700 w-full text-center"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default Editorpop;